import { type Assessment } from "@core/assessments/types";
import { AssessmentCard } from "./AssessmentCard";

type AssessmentsSectionProps = {
  assessments: Assessment[];
};

export function AssessmentsSection({ assessments }: AssessmentsSectionProps) {
  if (!assessments?.length) return null;

  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {assessments.map((assessment) => (
        <AssessmentCard key={assessment.id} assessment={assessment} />
      ))}
    </div>
  );
}
